import angular from 'angular';

import PlanService from './plan.service';

export default angular
    .module('common.service.payment', [])
    .service('planService', PlanService);



// WEBPACK FOOTER //
// ./src/common/service/payment/index.js